import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import styles from './index.css';

/**
 * for this page
 */
import StockSearch from './stockSearch';

class SearchBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        noticeTop: 0,
        totalLen: this.props.content.length,
        timer: '',
    };

    componentDidMount() {
        this.startScroll();
    }

    scrollNotice = () => {
        this.setState({
            noticeTop: this.state.noticeTop < this.state.totalLen ? this.state.noticeTop + 1 : 0,
        });
    };

    pauseScroll = () => {
        if (this.state.timer !== '') {
            clearInterval(this.state.timer);
            this.setState({
                timer: '',
            });
        }
    };

    startScroll = () => {
        if (this.state.timer === '') {
            const timer = setInterval(this.scrollNotice, 2000);

            this.setState({
                timer,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { noticeTop } = this.state;

        return (
            <div className={styles.searchBox}>
                <StockSearch />
                <div className={styles.notice}>
                    <p>公告：</p>
                    <div className={styles.noticeList}>
                        <ul
                            id="notice"
                            style={{
                                marginTop: `${-24 * noticeTop}px`,
                                transition: noticeTop === 0 ? 'none' : 'all 0.6s',
                            }}
                            onMouseEnter={this.pauseScroll}
                            onMouseOut={this.startScroll}>
                            {[...content, content[0]].map((item, index) => (
                                <li key={index}>
                                    <a href={item[0].url} rel={rel} target="_blank">
                                        {item[0].name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(SearchBox);
